import { render, staticRenderFns } from "./plus-customer-list.vue?vue&type=template&id=5ec59952&scoped=true"
import script from "./plus-customer-list.vue?vue&type=script&lang=js"
export * from "./plus-customer-list.vue?vue&type=script&lang=js"
import style0 from "./plus-customer-list.vue?vue&type=style&index=0&id=5ec59952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec59952",
  null
  
)

export default component.exports